export default __webpack_public_path__ + "static/media/ejemplo_dom_fiscal.324b5c43.jpeg";